<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <div class="row" id="loading-container">
          <div class="col-md-3">
            <div class="card">
              <div class="card-header p-3 bg-light">
                Directories
              </div>
              <div style="height: calc(100vh - 260px); overflow-y: auto;">
                <nav class="mt-2">
                  <ul class="nav nav-pills nav-sidebar nav-child-indent flex-column" data-accordion="false" data-widget="treeview" role="menu">
                    <li v-for="folder in folders" :key="folder.id" class="nav-item" :class="{'menu-open': isGroupOpened(folder)}">
                      <a href="#" class="nav-link" @click.prevent="toggleGroup(folder)">
                        <i class="fas fa-angle-right"></i>
                        {{ folder.name }}
                      </a>

                      <ul class="nav nav-sidebar nav-treeview">
                        <li v-for="subFolder in folder.subFolders" :key="subFolder.id" class="nav-item" :class="{'menu-open': isSubGroupOpened(subFolder)}">
                          <a href="#" :class="{'nav-link': true, 'active': isSubGroupOpened(subFolder)}" @click.prevent="toggleSubGroup(subFolder)">
                            <i class="fas fa-angle-right"></i>
                            {{ subFolder.name }}
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>

          <div class="col-md-9">
            <div class="card">
              <div class="card-header p-2 bg-light">
                Files
                <button @click="$refs.loadFileModal.toggle()" class="ml-2 btn btn-outline-primary btn-xs btn-control float-right" title="Import"><i class="fa fa-download"></i></button>
              </div>
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th>Filename</th>
                  <th>Date</th>
                  <th class="text-right">Actions</th>
                </tr>
                </thead>

                <tbody v-if="this.selectedFolder || this.selectedGroup">
                  <tr v-for="file in selectedGroup" :key="file.id" class="paginate-show">
                    <td><a :href="file.path" target="_blank">
                      {{file.name}}
                    </a>
                    </td>
                    <td>{{file.date}}</td>
                    <td class="text-right">
                      <button :id="'remove-file-btn-' + file.id" @click.stop class="btn btn-outline-danger btn-xs btn-control" title="Delete"><i class="fas fa-trash"></i></button>
                      <b-popover :ref="'deleteFilePopover' + file.id" placement="left" boundary="window" :target="'remove-file-btn-' + file.id" :title="'Delete file \'' + file.name + '\'?'">
                        <div class="text-right">
                          <button type="button" @click="closePopover('deleteFilePopover' + file.id)" class="btn btn-light btn-sm">Cancel</button>
                          <button type="button" @click="deleteFile(file)" class="ml-2 btn btn-danger btn-sm">Delete</button>
                        </div>
                      </b-popover>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <LoadFileModal ref="loadFileModal"
                       @onComplete="loadData"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<style>
.nav-link.selected {
  font-weight: bold;
}

.nav-sidebar .menu-is-opening>.nav-link i.fa-angle-right, .nav-sidebar .menu-open>.nav-link i.fa-angle-right {
  transform: rotate(90deg);
}
.btn-control.btn-xs {
  width: 25px;
}
</style>

<script>

import {getRouteIcon, ROUTE_LOCALIZATION} from "../../utils/routerIcons";
import StatsModal from "../../components/Localization/StatsModal";
import ExportModal from "../../components/Localization/ExportModal";
import LoadFileModal from "./LoadFileModal.vue";
import HelpAndTournamentsModal from "../../components/Localization/HelpAndTournamentsModal";

export default {
  data() {
    return {
      openedGroups: [],
      openedSubGroups: [],
      groups: [],
      terms: [],
      translations: [],
      isUploaded: false,
      selectedFolder: null,
      selectedGroup: null,
      deployBtnDisabled: false,
      isUpdating: false,
    }
  },
  components: {
    StatsModal,
    ExportModal,
    LoadFileModal,
    HelpAndTournamentsModal,
  },
  computed: {
    deployBtnIcon() {
      return this.deployBtnDisabled ? 'fas fa-spinner fa-pulse' : 'fa fa-share-square';
    },
    routeIcon: () => getRouteIcon(ROUTE_LOCALIZATION),
    folders: function () {
      return this.groups;
    }
  },
  methods: {
    isTermSelected(folder) {
      if (!this.selectedFolder) {
        return false;
      }
      return this.selectedFolder.id === folder.id;
    },
    selectTerm(term, group) {
      this.selectedFolder = term;
      if (group.files) {
        this.selectedGroup = group.files;
      }
    },
    isGroupOpened(group) {
      return this.openedGroups.indexOf(group.id) >= 0;
    },
    isSubGroupOpened(group) {
      return this.openedSubGroups.indexOf(group.id) >= 0;
    },
    toggleGroup(group) {
      if (this.isGroupOpened(group)) {
        this.openedGroups = [];
        this.openedSubGroups = [];
        this.selectedGroup = [];
        return;
      }
      this.openedGroups = [];
      this.openedGroups.push(group.id);
    },
    toggleSubGroup(group) {
      if (this.isSubGroupOpened(group)) {
        this.openedSubGroups = [];
        this.selectedGroup = [];
        return;
      }
      this.openedSubGroups = [];
      this.openedSubGroups.push(group.id);
      this.selectTerm(null, group)
    },
    getGroupTerms(group) {
      return this.terms.filter((term) => term.groupId === group.id)
    },
    closePopover(ref) {
      this.$refs[ref][0].$emit('close');
    },
    deleteFile(file) {
      this
          .$http({
            url: '/api/v1/files/' + file.id,
            method: 'DELETE',
          })
          .then(() => {
            this.selectedGroup = this.selectedGroup.filter((item) => item.id !== file.id);
            this.$refs['deleteFilePopover' + file.id][0].$emit('close');
            this.$toastr.i('Success');
          })
          .catch((err) => {
            const message = err.response?.data?.message ?? err.response?.data?.error ?? 'Failed to delete file';
            this.$toastr.e(typeof message === 'string' ? message : JSON.stringify(message));
          });
    },
    loadData() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });
      loadingInstance.show();

      Promise.all([
        this
            .$http({
              url: '/api/v1/files',
              method: 'GET',
            })
            .then(resp => {
              this.groups = resp.data;
            })
      ])
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loadingInstance.close();
          });

    }
  },
  mounted() {
    this.loadData();
  }
}
</script>
